import styled, { css } from 'styled-components'
import { BP } from 'resources/constants'
import { containerCss } from 'app/sofia/components/Structure/Container'
import { sectionCss } from 'app/sofia/components/Structure/Section'
import { heading2, buttonGreen, buttonPrimaryOutline, buttonSizeLg } from 'app/sofia/resources/theme/css'
import { heading3, buttonPrimary } from 'app/livbrite/resources/theme/css'

export const iconCss = css`
  svg + span,
  span + svg { margin-left: 8px; }

  svg {
    height: 20px;
    width: 20px;
  }
`

export const Button = styled.button<any>`
  ${buttonGreen}
  ${props => props.isLivbrite ? buttonPrimary : buttonSizeLg};
  display: inline-flex;
  ${props => props.isDisabled && `
    pointer-events: none;
    opacity: 0.5;
  `}

  &.link {
    ${props => props.theme.css.link};
    color: ${props => props.theme.palette.general.strong};
    height: auto;
    cursor: pointer;
    padding: 0;
    margin: 0;
    border: 0;
    background: none;
    text-decoration: none;
    font-size: 16px;
    ${iconCss}
  }

  &.results-back {
    position: absolute;
    z-index: 9;

    @media (max-width: ${BP.sm.max}) {
      left: 15px;
      top: 15px;
      ${props => props.theme.css.link};
      text-decoration: none;
      background: none;
      height: auto;
      padding: 0;
      font-size: 16px;
      border: 0;
      font-weight: 600;
    }

    @media (min-width: ${BP.sm.min}) {
      ${buttonPrimaryOutline}
      left: 30px;
      top: 30px;
    }
  }

  .icon {
    ${iconCss}
  }
`

export const PageWrapper = styled.div`
  position: relative;
`

export const Section = styled.section`
  ${sectionCss};
  background: ${props => props.theme.palette.primary.alpha};
  position: relative;
  max-width: none;

  @media (min-width: ${BP.sm.min}) {
    margin-bottom: 15px;
  }

  &.step-review {
    background-color: ${props => props.theme.productSelector.reviewBgColor};
  }
`

export const Container = styled.div`
  ${containerCss}

  @media (min-width: ${BP.sm.min}) {
    margin-bottom: 20px;
  }

  @media (min-width: ${BP.md.min}) {
    margin-bottom: 40px;
  }
`

export const SelectorContent = styled.div`
  margin: 0 auto;

  @media (min-width: ${BP.sm.min}) {
    width: ${BP.xs.min};
  }
`

export const ContentBlock = styled.div<any>`
  padding: 20px;

  @media (min-width: ${BP.sm.min}) {
    padding: 30px;
  }
`

export const itemPressedCss = css`
  box-shadow: inset 0 3px 3px rgba(0, 0, 0, 0.2);
  border-color: ${props => props.theme.palette.primary.alphaDark};
  background: ${props => props.theme.palette.primary.alphaLight};
`

export const itemSelectedCss = css`
  border-color: ${props => props.theme.palette.primary.beta};
  background: ${props => props.theme.palette.primary.greyExtraLight};
`

export const Items = styled.div<any>`
  --itemSize: 70px;

  label {
    position: relative;
    display: block;
    cursor: pointer;

    &.numeric {
      display: inline-block !important;
      width: calc(50% - 4px);

      &:nth-child(even) {
        margin-left: 8px;
      }
    }

    input {
      position: absolute;
      left: -30px;
      opacity: 0;
      visibility: hidden;

      &:checked + .item {
        ${itemSelectedCss}

        > .icon-wrap .icon {
          background-color: ${props => props.theme.palette.primary.beta};
        }
      }
    }

    & + label {
      margin-top: 10px;
    }
  }

  .item {
    background: ${props => props.theme.palette.general.light};
    padding: 10px;
    border-radius: 4px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1);
    display: flex;
    align-items: center;
    cursor: pointer;
    border: 3px solid transparent;

    @media (min-width: ${BP.sm.min}) {
      padding: 15px;
    }

    &:hover {
      border-color: ${props => props.theme.palette.primary.alphaDark};
    }

    > .icon-wrap {
      margin-right: 15px;

      @media (min-width: ${BP.sm.min}) {
        margin-right: 20px;
      }

      > .icon {
        padding: 5px;
        border-radius: 100%;
        width: calc(var(--itemSize) - 30px);
        height: calc(var(--itemSize) - 30px);
        text-align: center;
        display: flex;
        align-items: center;
        background-color: ${props => props.theme.palette.primary.alphaMutted};
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
      }
    }

    > .label {
      &._no-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        text-align: center;
        min-height: calc(var(--itemSize) - 6px);

        @media (min-width: ${BP.sm.min}) {
          min-height: var(--itemSize);
        }
      }

      p {
        font-weight: 400;
        font-size: ${props => props.isLivbrite ? '18px' : '16px'};
        margin: 0;
        line-height: 1.2;

        strong {
          font-weight: ${props => props.theme.font.default.bold};
        }

        @media (min-width: ${BP.sm.min}) {
          font-size: ${props => props.isLivbrite ? '22px' : '18px'};
        }
      }
    }

    &.result {
      margin-bottom: 15px;
      border: 0;
      align-items: stretch;
      padding: 0;

      .label {
        padding: 15px;
      }

      > .icon-wrap {
        margin: 0 0 0 auto;
        background: ${props => props.theme.productSelector.reviewColorDark};
        display: flex;
        align-items: center;
        padding: 2px;
        border-radius: 0 4px 4px 0;

        svg {
          width: ${props => props.isLivbrite ? '30px' : '20px'};
          height: ${props => props.isLivbrite ? '30px' : '20px'};
        }
      }
    }
  }
`

export const Actions = styled.div`
  .submit-wrap {
    text-align: center;
    margin-top: 15px;

    > button {
      background-color: ${props => props.theme.palette.general.strong};
      border-color: ${props => props.theme.palette.general.strong};
    }
  }

  .nav-wrap {
    margin-top: 25px;
    text-align: center;
  }

  a {
    ${props => props.theme.css.link};
    font-weight: 600;
    text-decoration: none;
    ${iconCss}
  }
`

export const Header = styled.header<any>`
  text-align: center;
  margin-bottom: 25px;
  color: ${props => props.isSofia ? props.theme.palette.general.strong : props.theme.palette.primary.alphaDark};

  h1,
  h2 {
    ${props => props.theme.css.heading1};
    line-height: 1.1;
    margin: 0 0 15px;

    @media (min-width: ${BP.sm.min}) {
      margin-bottom: 15px;
    }
  }

  h3,
  h4,
  h5 {
    ${props => props.isSofia ? heading2 : heading3}
    text-transform: none;
    line-height: 1.3;
    margin: 0 0 15px;

    @media (min-width: ${BP.sm.min}) {
      margin-bottom: 20px;
    }
  }

  p {
    margin: 0 0 15px;
    font-size: 18px;
    line-height: 1.35;

    &:last-child {
      margin: 0;
    }
  }
`

export const SliderContainer = styled.div`
  padding: 0 20px;

  > div[class*='Slider'] {
    width: 100%;
    background: #fff;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.15);

    > div {
      &:first-child {
        background: #fff;
      }

      &:last-child {
        > div {
          height: 28px;
          width: 28px;
          position: relative;
          background: #fff;
          box-shadow: 0 3px 6px rgba(0, 0, 0, 0.2);

          &::after {
            content: '';
            height: 18px;
            width: 18px;
            border-radius: 50%;
            background: ${props => props.theme.palette.primary.alphaDark};
            position: absolute;
            left: 5px;
            top: 5px;
          }
        }
      }
    }
  }

  .slider-info {
    margin-top: 20px;
    text-align: center;
    position: relative;

    .mm {
      position: absolute;
      top: 0;
      font-weight: 600;
      font-size: 22px;

      &._min { left: 0; }
      &._max { right: 0; }
    }

    input {
      text-align: center;
      padding: 10px;
      border-radius: 5px;
      border: 1px solid ${props => props.theme.palette.general.borderColorLight};
      width: 150px;
      height: 55px;
      box-sizing: border-box;
      font-size: 20px;
      margin-top: 20px;
      outline: none;
      background: #fff;
      cursor: default;

      &:focus,
      &:active {
        background: #fff;
        border: 1px solid ${props => props.theme.palette.general.borderColorLight};
      }
    }
  }
`
